module.exports = __webpack_public_path__ + "img/bz1.10131694.png";